
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { isTokenExpired } from "../../helpers/jwt-token-access/cookies";
import { FetchConstDetails } from "../../store/actions";
import AppLogo from "../../components/Common/AppLogo";
import Cookies from 'js-cookie'


const Authmiddleware = (props) => {
  const dispatch = useDispatch();
  const ConstDetailsProp = useSelector(state => state.Login.constDetails)
  const { billing_setup, card_setup, loading, success: constApiSuccess } = ConstDetailsProp
  const [constLoading, setConstLoading] = useState(true);
  const isLoggedIn = Cookies.get("SESSION_ID")
  const history = useNavigate();


  useEffect(() => {
    setConstLoading(loading)
  }, [loading])

  React.useEffect(() => {
    if (isLoggedIn) {
      setConstLoading(true)
      dispatch(FetchConstDetails({ history }))
    }
  }, []);




  if (!isLoggedIn) {
    return <Navigate to={{ pathname: "/login" }} />;
  }
  else {
    if (constLoading) {
      return <AppLogo />;

    }
    else if (constApiSuccess) {

      // if (props.path !== "/settings/billing-details/setup" && (!billing_setup || !card_setup)) {
      //   return <Navigate to={{ pathname: "/settings/billing-details/setup" }} />

      // }
      return <React.Fragment>{props.children}</React.Fragment>;
    }
  }


};

export default Authmiddleware;
